import AuthApi from "apis/authApi";
import ActionCreator from "./common";
import { ActionTypes } from "store/actionTypes";
import { AppDispatch, RootState } from "store";
import { User } from "@auth0/auth0-react";

class AuthAction extends ActionCreator<AuthApi> {
    private Service;

    constructor() {
        super(AuthApi, ActionTypes.AUTH_LOADING, ActionTypes.AUTH_ERROR);

        this.Service = new AuthApi();
    }

    public initialize = () => ({
        type: ActionTypes.AUTH_INITIALIZE,
    });

    public setAccessToken = (token: string | null) => ({
        type: ActionTypes.SET_ACCESS_TOKEN,
        payload: token,
    });

    public setUserData = (user: User | null) => ({
        type: ActionTypes.SET_USER_DATA,
        payload: user,
    });
}

export default new AuthAction();
